import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddSupplierComponent } from '../../popups/add-supplier/add-supplier.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Supplier } from '../../shared/classes/supplier';
import { DataService } from '../../shared/services/data.service';
import { UserService } from '../../shared/services/user/user.service';
import { AuthService } from '../../shared/services/auth.service';
import { iif, firstValueFrom } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-suppliers',
    templateUrl: './suppliers.component.html',
    styleUrls: ['./suppliers.component.scss'],
    standalone: true,
    imports: [FormsModule, MatProgressSpinner, NgxPaginationModule]
})
export class SuppliersComponent implements OnInit {
    public page = 1;
    public supplierList: Supplier[];
    public supplierFilteredList: Supplier[];
    public site: string;
    public listLoaded = false;
    public searchFilter: string;
    private isAdmin = false;

    constructor(
        private dialog: MatDialog,
        private dataService: DataService,
        private userService: UserService,
        private authService: AuthService,
        private router: Router
    ) {}

    async ngOnInit() {
        const user = this.authService.user();

        if (!user) {
            void this.router.navigate(['/no-access']);
            return;
        }

        this.isAdmin = user.role === 'Admin';

        if (!this.isAdmin) {
            console.log('User is not an admin. Redirecting to unauthorized page.');
            void this.router.navigate(['/no-access']);
            return;
        }

        this.site = user.site;

        iif(
            () => this.userService.isUsersLoaded(),
            this.userService.usersObservable,
            this.userService.getUsers()
        ).subscribe((suppliers) => {
            this.supplierList = suppliers;
            this.filterSupplierList();
            this.listLoaded = true;
        });
    }

    async refresh(): Promise<void> {
        this.supplierList = await this.dataService.getSuppliers();
        this.site = await this.dataService.getSite();
        this.filterSupplierList();
        this.listLoaded = true;
        console.log(this.supplierList);
    }

    public filterSupplierList(): void {
        this.page = 1;
        this.supplierFilteredList = this.supplierList.slice().filter((item) => {
            if (
                this.searchFilter &&
                !(
                    (item.supplierID && item.supplierID.toUpperCase().includes(this.searchFilter.toUpperCase())) ||
                    (item.companyName && item.companyName.toUpperCase().includes(this.searchFilter.toUpperCase())) ||
                    (item.email && item.email.toUpperCase().includes(this.searchFilter.toUpperCase()))
                )
            ) {
                return false;
            }

            return true;
        });
    }

    public addSupplier(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        this.dialog.open(AddSupplierComponent, dialogConfig);
    }

    public deleteSupplier(supplier: Supplier): void {
        if (confirm(`Are you sure you want to delete supplier ${supplier.supplierID}?`)) {
            firstValueFrom(this.userService.deleteUser(supplier.supplierID)).then(() => {
                alert('Supplier was deleted successfully');
                window.location.reload();
            });
        }
    }
}
